import Layout from "../Frames/Layout"
import Editor from "./Certificate/Editor"
import { Stack } from "@mui/material"
import Top from "./Common/Top"
import { txt } from "../../services/translation"

export default function Certificate(){

    return <Layout menu='design' tab='certificate'>

        <Stack spacing={4} sx={{maxWidth: 800, margin: 'auto'}}>

            <Top title={txt('successCertificate')} />

            <Editor />

        </Stack>

    </Layout>
}
